export const QUERIES = {
  userSuggestions: 'user-suggestions',
};
